import React, { useEffect, useState } from 'react';
import { SimService } from 'services/sim/sim';
import { finalize } from 'rxjs/operators';
import { throwError } from 'rxjs';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';
import Card from 'components/Card/Card';
import Button from 'components/CustomButtons/Button';
import { translate } from 'components/Translation';
import SimCardImage from 'assets/img/numbers/settings/sim-card-image.svg';
import styles from 'assets/jss/material-dashboard-pro-react/views/settingsSubpageStyle';
import { makeStyles } from '@material-ui/core';
import { SimDetail } from 'utils/api/models/accounts/customerAccountResponse';
import { SimType } from 'utils/api/payloads/microApi';
import PinPukRow from '../../PinPukRow';
import Delete from '@material-ui/icons/DeleteOutlined';
import IconButton from 'components/CustomButtons/IconButton';
import CustomCircularProgress from 'components/CustomCircularProgress/CustomCircularProgress';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IDataSimProps {
	simsDetail?: SimDetail | undefined;
	phoneNumber: string;
	simType: SimType;
	showRemoveCardDialog: () => void;
	showReplaceSimCardDialog: () => void;
	showReplaceEsimCardDialog: () => void;
}

interface ISimDetails {
	activationCode?: string;
	networkId?: string;
	pin1?: string;
	pin2?: string;
	puk1?: string;
	puk2?: string;
	qrCode?: string;
	serialNumber?: string;
	url?: string;
}

const SimData = ({
	simsDetail,
	phoneNumber,
	simType,
	showReplaceSimCardDialog,
	showReplaceEsimCardDialog,
	showRemoveCardDialog,
}: IDataSimProps) => {
	const classes = useStyles();
	const [simResponse, setSimResponse] = useState<ISimDetails>();
	const [loading, setLoading] = useState<boolean>(false);

	useEffect(() => {
		if (simsDetail?.serialNo) {
			setLoading(true);
			SimService.getSimDetails(phoneNumber, simsDetail?.serialNo)
				.pipe(
					finalize(() => {
						setLoading(false);
					})
				)
				.subscribe(
					({ response }) => {
						if (response) {
							setSimResponse(response);
						}
					},
					(error) => throwError(error)
				);
		}
	}, [phoneNumber, simsDetail]);
	return (
		<ConditionalRender
			show={loading}
			onTrue={() => (
				<div className={classes.circularProgressWrapper}>
					<CustomCircularProgress text={''} transparent loading />
				</div>
			)}
			onFalse={() => (
				<ConditionalRender
					show={!!simResponse?.serialNumber}
					onTrue={() => (
						<Card className={classes.dataSawaCardWrapper}>
							<div className={classes.dataSawaCard}>
								<img src={SimCardImage} alt="Sim card" className={classes.dataSawaSimImg} />
								<PinPukRow label={translate('numbers.settings.pin1')} value={simResponse?.pin1 || ''} />
								<PinPukRow label={translate('numbers.settings.puk1')} value={simResponse?.puk1 || ''} />
								<PinPukRow label={translate('numbers.settings.pin2')} value={simResponse?.pin2 || ''} />
								<PinPukRow label={translate('numbers.settings.puk2')} value={simResponse?.puk2 || ''} />
								<PinPukRow
									label={translate('numbers.settings.sim')}
									value={simResponse?.serialNumber || ''}
								/>
							</div>
							<div onClick={() => {}} className={classes.deleteButtonWrapper}>
								<IconButton size="sm" onClick={showRemoveCardDialog}>
									<Delete />
								</IconButton>
							</div>
							{/* For ODF-6290 hide replace sim for esim and sim for data and sawa sim */}
							{/* 
							<GridContainer>
								<GridItem>
									<div onClick={showReplaceSimCardDialog}>
										<Button color="tertiary-light">{translate('replace.sim')}</Button>
									</div>
								</GridItem>
								
								<GridItem>
										<div onClick={showReplaceEsimCardDialog}>
											<Button color="tertiary-light">{translate('replace.esim')}</Button>
										</div>
									</GridItem>
								
							</GridContainer>
							*/}
						</Card>
					)}
				/>
			)}
		/>
	);
};

export default SimData;
